/**
 * The plan catalog and the workspace's contact usage (V46), cached with
 * react-query so the Billing page, the settings tab and the app-shell banner
 * share one fetch each.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchContactUsage, fetchPlanCatalog } from '@/services/billingPlans';

export function usePlanCatalog() {
  return useQuery({
    queryKey: ['billing', 'plans'],
    queryFn: fetchPlanCatalog,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}

export function useContactUsage(enabled = true) {
  return useQuery({
    queryKey: ['billing', 'contacts'],
    queryFn: fetchContactUsage,
    staleTime: 5 * 60 * 1000,
    retry: false,
    enabled,
  });
}
